import logger from './middleware/logger'
import thunk from './middleware/redux-thunk'

export const options = {
    historyMode:'browser',
    middlewares:[logger,thunk],
    reducers:{}
}

const historyModes = ['browser', 'hash', 'memory']

// Can be called multiple times, ie. after load an async component that has
// exported standard Redux `reducer`s that need to be `replaceReducer` for the
// store.
//
// After the first time called, all later calls will try to *merge* `opts.reducers`
// into the previous `options.reducers`, other keys like `historyMode` will be *updated*
// if it is provided, otherwise it will be ignored, which means the previous values will
// be kept.
export default function defaults(opts = {}) {

  const {
    historyMode,
    middlewares
  } = opts

  if (historyMode && !historyModes.includes(historyMode)) {
    throw new Error(`historyMode "${historyMode}" is invalid, must be one of ${historyModes.join(', ')}!`)
  }

  if (middlewares && !Array.isArray(middlewares)) {
    throw new Error(`middlewares "${middlewares}" is invalid, must be an Array!`)
  }
  Object.keys(opts).forEach(key => {
    if (key === 'reducers') {
      options[key] = {
        ...options[key],
        ...opts[key]
      }
    } else {
      if(key === "middleware"){
        options[key] = options[key].concat(opts[key]);
      } else{
        options[key] = opts[key]
      }
    }
  })
}
